// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__Nl8zb","title":"Section_title__pFEWm","body":"Section_body__ethci"};